import React, { forwardRef, useEffect, useState } from 'react';
import styles from './OrganisationOther.module.scss';
import { validate, isCompleted } from '../Utils/Validation';
import { Notification, FormInput } from '@snsw/react-component-library';

const OrganisationOther = (props, ref) => {
  if (ref) {
    ref.current = {
      validate: () => {
        const isValid = validate(validators, setErrors);
        setShowErrors(!isValid);
        return isValid;
      }
    };
  }

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const validators = [
    {
      fieldName: 'registrationNumber',
      fieldValue: props.registrationNumber,
      isValid: isCompleted
    },
    {
      fieldName: 'orgName',
      fieldValue: props.orgName,
      isValid: isCompleted
    },
    {
      fieldName: 'tradingName',
      fieldValue: props.tradingName,
      isValid: isCompleted
    }
  ];

  useEffect(() => {
    if (showErrors) {
      const isValid = validate(validators, setErrors);
      setShowErrors(!isValid);
    }
  }, [props.registrationNumber]);

  return (
    <>
      <div className={'row'}>
        <div className={`col-12`}>
          <FormInput
            placeholder={'Registration number'}
            errorMessage={'Registration Number is required.'}
            hasError={showErrors && errors.YINCDetails}
            label="Registration number"
            value={props.registrationNumber}
            onChange={(evt) => {
              if (props.setRegistrationNumber) {
                props.setRegistrationNumber(evt.target.value);
              }
            }}
          />
        </div>
      </div>

      <div className={'row'}>
        <div className={`col-12`}>
          <FormInput
            label={'Organisation Name'}
            errorMessage={'Organisation Name is required.'}
            hasError={showErrors && errors.OrgName}
            value={props.orgName}
            onChange={(evt) => {
              props.setOrgName(evt.target.value);
            }}
          />
        </div>
      </div>
      <div className={'row'}>
        <div className={`col-12 ${styles.section}`}>
          <FormInput
            label={'Registered Trading Name'}
            errorMessage={'Registered Trading Name is required.'}
            hasError={showErrors && errors.tradingName}
            value={props.tradingName}
            onChange={(evt) => {
              props.setTradingName(evt.target.value);
            }}
          />
        </div>
      </div>
    </>
  );
};
export default forwardRef(OrganisationOther);
